import React from 'react';
import { Container, Group, Title, Item } from './options-group.styles';
var OptionsGroup = function (_a) {
    var id = _a.id, title = _a.title, options = _a.options, settings = _a.settings, isActiveOption = _a.isActiveOption, onClick = _a.onClick;
    return (React.createElement(Container, null,
        React.createElement(Title, null, title),
        React.createElement(Group, null, options.map(function (_a) {
            var label = _a.label, isActive = _a.isActive, defaultValue = _a.defaultValue;
            return (React.createElement(Item, { key: label, isActive: isActiveOption && isActive(settings), onClick: function (e) { return onClick(e, id, defaultValue); } }, label));
        }))));
};
export default OptionsGroup;
